<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="10" :sm="24" v-if="!read_only">
        <el-card class="box-card">
          <div slot="header" class="text-center">
            {{ (form.id) ? 'Editando' : 'Nuevo' }} Contrato
          </div>
          <el-form ref="form"
                   label-position="top"
                   :model="form"
                   label-width="120px"
                   :rules="rules">
            <el-row :gutter="10">
              <el-form-item label="Tipo de contrato" prop="contract_types">
                <el-select v-model="form.contract_types"
                           :disabled="form.contract_ended == 1 || canEditToSave()"
                           placeholder="Seleccione uno opción">
                  <el-option
                    v-for="item in contract_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-col :md="24">
              </el-col>
              <el-col :md="12">
                <el-form-item label="Fecha de Inicio" prop="start_date">
                  <el-date-picker type="date"
                                  :disabled="form.contract_ended == 1 || canEditToSave()"
                                  v-model="form.start_date"
                                  placeholder="Seleccione una fecha"
                                  style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item v-if="form.contract_types == 'Definido'" label="Fecha Final" prop="end_date">
                  <el-date-picker type="date"
                                  :disabled="form.contract_ended == 1 || canEditToSave()"
                                  v-model="form.end_date"
                                  placeholder="Seleccione una fecha"
                                  style="width: 100%;"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Centro de Costo" prop="cost_center_id">
                  <el-select v-model="form.cost_center_id"
                             :disabled="form.contract_ended == 1 || canEditToSave()"
                             :placeholder="(loadingCostCenters) ? 'Cargando...' : 'Seleccionar'"
                             style="width: 100%;">
                    <el-option
                      v-for="item in cost_centers"
                      :disabled="canEditToSave()"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.company.name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Planilla" prop="payroll_id">
                  <el-select v-model="form.payroll_id"
                             :disabled="form.contract_ended == 1 || canEditToSave()"
                             :placeholder="(loadingPayRolls) ? 'Cargando...' :'Seleccionar'"
                             style="width: 100%;">
                    <el-option
                      v-for="item in payrolls"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Posición Laboral" prop="position_id">
                  <el-select
                    v-model="form.position_id"
                    :disabled="form.contract_ended == 1 || canEditToSave()"
                    @change="onChangePosition()"
                    :placeholder="(loadingPositions) ? 'Cargando...' :'Seleccionar'">
                    <el-option
                      v-for="item in positions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Metodo de pago" prop="payment_method">
                  <el-select v-model="form.payment_method_id"
                             :disabled="form.contract_ended == 1 || canEditToSave()"
                             placeholder="Seleccione uno opción">
                    <el-option
                      v-for="item in paymentMethods"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Plantilla de contrato" prop="template_id">
                  <el-select v-model="form.template_id"
                             :disabled="form.contract_ended == 1 || canEditToSave()"
                             placeholder="Seleccione uno opción">
                    <el-option
                      v-for="item in templates"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Salario" prop="salary">
                  <el-input-number v-model="form.salary"
                                   :disabled="form.contract_ended == 1 || canEditToSave()"
                                   :min="0"
                                   controls-position="right"
                                   style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-form-item prop="observation" label="Observación">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="Escriba una observación (opcional)"
                    v-model="form.observations">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item prop="has_transport" label="Planilla de Transporte">
                  <el-switch
                    v-model="form.has_transport"
                    :disabled="form.contract_ended == 1 || canEditToSave()"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Si"
                    inactive-text="No">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="form.has_transport">
                <el-form-item label="Monto de Transporte" prop="transport_cash">
                  <el-input-number v-model="form.transport_cash"
                                   :min="0"
                                   :disabled="canEditToSave()"
                                   controls-position="right"
                                   style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-dialog @close="clearContractForm()" title="Finalizar contrato" :visible.sync="dialogFormVisible" append-to-body>
                  <el-form :model="form" :rules="contractRules" ref="contractForm">
                    <el-form-item label="Fecha de Finalizacion" prop="date_ended">
                      <el-date-picker type="date"
                                      :disabled="canEditToSave()"
                                      v-model="form.date_ended"
                                      placeholder="Seleccione una fecha"
                                      style="width: 100%;"
                                      format="dd-MM-yyyy"
                                      value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Motivo" prop="reason_id">
                      <el-select v-model="form.reason_id"
                                 :disabled="canEditToSave()"
                                 placeholder="Seleccione uno opción">
                        <el-option
                          v-for="item in reasons"
                          :key="item.id"
                          :label="item.reason"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Observación de finalizacion" prop="cont_ended_observation">
                      <el-input
                        type="textarea"
                        autosize
                        placeholder="Escriba una observación (opcional)"
                        v-model="form.cont_ended_observation">
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="blacklist" label="Agregar a lista no recontratable?">
                      <el-switch
                        v-model="form.blacklist"
                        :disabled="canEditToSave()"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="Si"
                        inactive-text="No">
                      </el-switch>
                    </el-form-item>
                    <el-col :md="12" v-if="form.blacklist">
                      <el-form-item label="Motivo" prop="blacklist_reason">
                        <el-input
                          type="textarea"
                          autosize
                          placeholder="Escriba un motivo"
                          v-model="form.blacklist_reason">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
    <el-button @click="clearContractForm()">Cancelar</el-button>
    <el-button type="primary" @click="saveContractEnded()">Confirmar</el-button>
  </span>
                </el-dialog>
              </el-col>
            </el-row>

            <div role="alert" v-if="error.message" class="el-alert el-alert--error">
              <div class="el-alert__content">
                <span class="el-alert__title is-bold">{{ error.message }}</span>
                <p class="el-alert__description">
                  <ul>
                    <li v-for="item in error.errors">{{ item[0] }}</li>
                  </ul>
                </p>
              </div>
            </div>

            <el-button @click="clear()">
              Cancelar
            </el-button>
            <el-button type="danger"  v-if="form.id" :disabled="form.contract_ended == 1 || processing" @click="showContractEndedDialog()">Finalizar contrato</el-button>
            <el-button type="primary"
                       v-if="!canEditToSave()"
                       style="margin-top: 20px"
                       :loading="processing"
                       @click="clearEndDate() || save()">
              <span v-if="!processing">Guardar</span>
              <span v-else>Procesando...</span>
            </el-button>
          </el-form>

        </el-card>
      </el-col>
      <el-col :md="read_only ? 24 : 14" :sm="read_only ? 24 : 14">
        <app-table
          @change-pagination="onChangePagination"
          @change-search="onChangeSearch"
          :total="total">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="Posición Laboral">
              <template slot-scope="scope">
                <p>{{ scope.row.position.name }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="start_date"
              label="Fecha I.">
            </el-table-column>
            <el-table-column
              prop="end_date"
              label="Fecha F.">
            </el-table-column>
            <el-table-column
              label="Planilla">
              <template slot-scope="scope">
                <p>{{ scope.row.payroll.name }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="Centro de Costos">
              <template slot-scope="scope">
                <p>{{ scope.row.cost_center.name }}</p>
              </template>
            </el-table-column>
            <el-table-column
              :width="120"
              v-if="!read_only"
              label="">
              <template slot-scope="scope">
                <el-button
                  v-if="canUpdate()"
                  size="mini"
                  type="warning"
                  @click="showDialog(scope.row)"><i class="el-icon-edit"></i></el-button>
                <el-button
                  v-if="canDelete()"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>

                <el-button
                  size="mini"
                  type="danger"
                  @click="generatePDF(scope.$index, scope.row)"><i class="fa fa-file-pdf-o"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </app-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  import {saveAs} from 'file-saver'

  export default {
    extends: BaseCrud,
    name: 'form-list',
    props: ['employee_id', 'read_only'],
    components: {
      AppTable, saveAs
    },
    data () {
      return {
        contract_type: [{
          value: 'Definido',
          label: 'Definido'
        }, {
          value: 'Indefinido',
          label: 'Indefinido'
        }

        ],
        dialogFormVisible: false,
        baseUrl: baseApi + '/contracts',
        loadingPayRolls: false,
        loadingPositions: false,
        payrolls: [
          {
            id: 1,
            name: 'General',
            company_id: 1,
            type: 'Quincena',
            pay_day: 12,
            weekly_payday: 0,
            transport_cash: 0.0
          }
        ],
        paymentMethods: [],
        basePermission: 'contracts',
        templates: [],
        loadingCostCenters: false,
        loadingReasons: false,
        loadingPayrolls: false,
        reasons: [],
        cost_centers: [],
        positions: [],
        form: {
          has_transport: false,
          contract_ended: false,
          blacklist: false,
          blacklist_reason: ''

        },
        formLabelWidth: '120px',
        contractRules: {
          date_ended: [{required: true, message: 'La Fecha de finalizacion es requerida', trigger: 'blur'}],
          reason_id: [{required: true, message: 'El motivo es requerido', trigger: 'blur'}],
          cont_ended_observation: [{required: true, message: 'La observacion es requerida', trigger: 'blur'}]
        },
        rules: {
          start_date: [{required: true, message: 'La Fecha de Inicio es requerida', trigger: 'blur'}],
          end_date: [{required: true, message: 'La Fecha Final es requerida', trigger: 'blur'}],
          cost_center_id: [{required: true, message: 'El Centro de Costo es requerido', trigger: 'blur'}],
          payroll_id: [{required: true, message: 'La Planilla es requerida', trigger: 'blur'}],
          position_id: [{required: true, message: 'La Posición Laboral es requerida', trigger: 'blur'}],
          salary: [
            {required: true, message: 'La Posición Laboral es requerida'}
          ]
        }
      }
    },
    watch: {
      employee_id (id) {
        console.log(id)
        this.clear()
        this.employee_id = id
        this.loadData()
        this.refreshData()
      }
    },
    methods: {
      clearContractForm () {
        this.$refs.contractForm.resetFields()
        this.dialogFormVisible = false
        this.form.contract_ended = false
        this.form.blacklist = false
        this.form.date_ended = null
      },
      clearEndDate () {
        if (this.form.contract_types === 'Indefinido') {
          this.form.end_date = null
        }
      },
      saveContractEnded () {
        this.$refs['contractForm'].validate((valid) => {
          if (valid) {
            this.dialogFormVisible = false
            this.save()
          }
        })
      },
      showContractEndedDialog () {
        this.dialogFormVisible = true
        this.form.contract_ended = true
        this.form.date_ended = new Date()
      },
      loadData () {
        this.loadingCostCenters = true
        this.$http.get(baseApi + '/cost-centers')
          .then(
            (response) => {
              this.cost_centers = response.body
              this.loadingCostCenters = false
            },
            (res) => {
              this._notifyError(parseError(res)[0])
              this.loadingCostCenters = false
            }
          )

        this.loadingReasons = true
        this.$http.get(baseApi + '/reasons')
          .then(
            (response) => {
              this.reasons = response.body
              this.loadingReasons = false
            },
            (res) => {
              this._notifyError(parseError(res)[0])
              this.loadingReasons = false
            }
          )

        this.loadingPositions = true
        this.$http.get(baseApi + '/positions')
          .then(
            (response) => {
              this.positions = response.body
              this.loadingPositions = false
            },
            (res) => {
              this._notifyError(parseError(res)[0])
              this.loadingPositions = false
            }
          )
        this.loadingPayRolls = true
        this.$http.get(baseApi + '/payrolls')
          .then(
            (response) => {
              this.payrolls = response.body
              this.loadingPayRolls = false
            },
            (res) => {
              this._notifyError(parseError(res)[0])
              this.loadingPayRolls = false
            }
          )
        this.$http.get(baseApi + '/templates/getlist')
          .then(
            (response) => {
              this.templates = response.body
            },
            (res) => {
              this._notifyError(parseError(res)[0])
            }
          )
      },
      _formatModel (model) {
        if (typeof (model.has_transport) !== typeof (true)) {
          model.has_transport = parseInt(model.has_transport)
        }
        if (typeof (model.contract_ended) !== typeof (true)) {
          model.contract_ended = parseInt(model.contract_ended)
        }
        model.has_transport = (model.has_transport === 1 || model.has_transport === true)
        model.contract_ended = (model.contract_ended === 1 || model.contract_ended === true)
        model.cost_center_id = parseInt(model.cost_center_id)
        model.payroll_id = parseInt(model.payroll_id)
        model.reason_id = parseInt(model.reason_id)
        model.position_id = parseInt(model.position_id)
        model.payment_method_id = parseInt(model.payment_method_id)
        model.template_id = parseInt(model.template_id)
      },
      showDialog (model) {
        if (model) {
          this._formatModel(model)
          this.actionText = 'Actualizar'
          this.form = {...model}
        } else {
          this.dialogTitle = 'Nuevo'
          this.actionText = 'Agregar'
          if (this.form.id) {
            this.form = {}
            this.$refs.form.resetFields()
          }
        }

        this.dialogTitle = this._getDialogTitle(this.form)
        this.dialogVisible = true
      },
      generatePDF (index, row) {
        const data = {'contract_id': row.id}
        let url = baseApi + '/contracts/generate'
        this.exporting = true
        this.$http.post(url, data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/pdf'}
        })
          .then(
            (response) => {
              console.log(row)
              const blob = new Blob([response.data], {type: 'application/pdf'})
              let filename = 'contracto ' + row.employee_id + row.start_date
              saveAs(blob, filename + '.pdf')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar el contrato de ' + model.position.name
      },
      _beforeRefresh (query) {
        query.employee_id = this.employee_id
      },
      _notifyError (message) {
        this.$notify.error({
          title: 'Error',
          message: message
        })
      },
      _beforeSend (model) {
        model.employee_id = this.employee_id
        return model
      },
      _mounted () {
        this.loadAll()
        this.loadData()
      },
      clear () {
        this.$refs.form.resetFields()
        this.form = {}
      },
      loadAll () {
        this.refreshData()
        this.$http.get(baseApi + '/payment_methods')
          .then(
            (res) => {
              this.paymentMethods = res.body
            }
          )
      },
      onChangePosition () {
        console.log(this.form.position_id, 'hello')
        let positions = this.positions.filter(position => position.id === this.form.position_id)
        if (positions.length > 0) {
          this.form.salary = positions[0].min_wage
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/employees/ContractList.vue